import React, { Dispatch, MouseEvent, useContext, useEffect, useMemo, useState } from "react";
import { AudienceAction, AudienceContext, AudienceProvider, Tchan, useAudienceContext } from "./AudienceStore";
import { NavigateFunction, Route, Routes, useNavigate } from "react-router-dom";
import { Audience, listAudiences } from "../audience-api";
import { AudiencePage } from "./AudiencePage";
import { MemberImporter } from "./MembersImporter";
import { Table } from "../table/Table";
import { Column } from "../table/Table";
import { DateUtils } from "simple-utils";
import { SiteHeader } from "../SiteHeader";
import { AudienceAddButton, AudienceItemActions } from "./AudienceForm";
import { MessageBox } from "../comps/MessageBox";
import { BackButtonBar } from "../comps/BackButton";

function goToAudience(a:Audience, navigate:NavigateFunction, dispatch:Dispatch<AudienceAction>){
    dispatch({type:"setAudience", payload: a})
    navigate(`./${a.id}`)
}

function AudienceTable(){
    const {dispatch} = useContext(AudienceContext);
    const {audiences} = useAudienceContext();
    const navigate = useNavigate();

    const columns:Column<Audience>[] = useMemo(() => {
        return [
            {id:"name", label: "Público", render: (i) => i.name},
            {id:"numMembers", label: "Contatos", render: (i) => i.numMembers},
            {id:"created", label: "Criação", render: (i) => DateUtils.formatDatetime(i.created)},
            {id:"actions", label: "Ações", render: (i) => <AudienceItemActions audience={i} />}
        ] as Column<Audience>[]
    }, [audiences])

    function onClick(item:Audience, e:MouseEvent){
        goToAudience(item, navigate, dispatch);
    }

    return <>
        <div className="table-view">
            <Table columns={columns} data={audiences} onClick={onClick} />
        </div>
        <div className="mt-4"><AudienceAddButton /></div>
    </>

    

}


function AudienceList(){
    const {dispatch} = useContext(AudienceContext);
    const {audiences} = useAudienceContext();
    
    useEffect(() =>{
        //if(audiences) return;
        (async () =>{ 
            const list = await listAudiences()
            dispatch({type:'setAudiences', payload: list})
        })()
    }, [])

    return  <>
        <BackButtonBar><h3 className="mb-0"><i className="fa fa-users"></i> Públicos</h3></BackButtonBar>
        
        <MessageBox className="mb-4">
            <div className="mb-2">Para enviar <b>mensagens</b> em massa, primeiro é necessário criar um <b>público-alvo.</b></div>
            Nesta área você pode criar, listar e editar o público alvo de suas campanhas de mensagem.
        </MessageBox>

        {audiences == null && <div className="text-muted">Loading...</div>}
        {audiences != null && <AudienceTable />}
    </>
}

export function AudienceIndex(){
    return <AudienceProvider>
        <div className="container my-4">
            <SiteHeader />
            <Routes>
                <Route path="/" element={<AudienceList />} />
                <Route path="/:id" element={<AudiencePage />} />
                <Route path="/:id/importar" element={<MemberImporter />} />
            </Routes>
        </div>
    </AudienceProvider>
}
